// extracted by mini-css-extract-plugin
module.exports = {"root":"app-dialog-content_root__jt-sE"};